import { AdminPrefetchProvider } from "@portal/providers/AdminPrefetchProvider";
import { PreviewFilterProvider } from "@portal/providers/PreviewFilterProvider";
import { SystemBannerProvider } from "@portal/providers/SystemBannerProvider";
import { AdminSuretyAccountView } from "@portal/views/account/admin/AdminAccountView";
import { AdminAccountSubmissionsView } from "@portal/views/admin/accounts/AdminAccountSubmissionsView";
import { AdminWrittenAccountsView } from "@portal/views/admin/accounts/AdminWrittenAccountsView";
import { AdminBondView } from "@portal/views/admin/bond/AdminBondView";
import { AdminBondsView } from "@portal/views/admin/bonds/AdminBondsView";
import { AdminDashboardView } from "@portal/views/admin/dashboard/AdminDasboardView";
import { AdminImportBondView } from "@portal/views/admin/import/AdminImportBondView";
import { AdminMainLayout } from "@portal/views/admin/layout/AdminMainLayout";
import { AdminMarketAnalyticsView } from "@portal/views/admin/market-analytics/AdminMarketAnalyticsView";
import { AdminBondRequestRedirect } from "@portal/views/admin/request/AdminBondRequestRedirect";
import { AdminBondRequestView } from "@portal/views/admin/request/AdminBondRequestView";
import { AdminRequestsView } from "@portal/views/admin/requests/AdminRequestsView";
import { AdminAgencyView } from "@portal/views/admin/settings/AdminAgencyView";
import { ManageAgenciesView } from "@portal/views/admin/settings/ManageAgenciesView";
import { ManageBondNumbersView } from "@portal/views/admin/settings/ManageBondNumbersView";
import { ManageEntityTagsView } from "@portal/views/admin/settings/ManageEntityTagsView";
import { ManageFeatureFlagsView } from "@portal/views/admin/settings/ManageFeatureFlagsView";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthGuard, RBACAuthGuard } from "./utils/guards";

export const AdminApp = () => {
	return (
		<AdminPrefetchProvider>
			<SystemBannerProvider audience="admin">
				<PreviewFilterProvider userType="admin">
					<AdminMainLayout>
						<Routes>
							<Route path="/" element={<AuthGuard component={AdminDashboardView} />} />
							<Route path="requests" element={<AuthGuard component={AdminRequestsView} />} />
							<Route
								path="requests/:id"
								element={<AuthGuard component={AdminBondRequestRedirect} />}
							/>
							<Route
								path="accounts/:accountId/requests/:id"
								element={<AuthGuard component={AdminBondRequestView} />}
							/>
							<Route path="bonds" element={<AuthGuard component={AdminBondsView} />} />
							<Route path="bonds/:id" element={<AuthGuard component={AdminBondView} />} />
							<Route path="accounts" element={<AuthGuard component={AdminWrittenAccountsView} />} />
							<Route
								path="submissions"
								element={<AuthGuard component={AdminAccountSubmissionsView} />}
							/>
							<Route
								path="accounts/:id"
								element={<AuthGuard component={AdminSuretyAccountView} />}
							/>
							<Route
								path="market-analytics"
								element={<AuthGuard component={AdminMarketAnalyticsView} />}
							/>
							<Route path="import">
								<Route path="bonds" element={<AuthGuard component={AdminImportBondView} />} />
							</Route>
							<Route path="agencies" element={<AuthGuard component={ManageAgenciesView} />} />
							<Route path="agencies/:id" element={<AuthGuard component={AdminAgencyView} />} />
							<Route path="entity-tags" element={<AuthGuard component={ManageEntityTagsView} />} />
							<Route
								path="bond-numbers"
								element={<AuthGuard component={ManageBondNumbersView} />}
							/>
							<Route
								path="feature-flags"
								element={
									<RBACAuthGuard
										component={ManageFeatureFlagsView}
										roles={["developer"]}
										rbacRedirectTo="/requests"
									/>
								}
							/>
							<Route path="*" element={<Navigate to="/requests" />} />
						</Routes>
					</AdminMainLayout>
				</PreviewFilterProvider>
			</SystemBannerProvider>
		</AdminPrefetchProvider>
	);
};
